import authAxios from "./axiosInstances/authAxios";
import JwtService from "@/core/services/JwtService";
import router from "@/router";
import { errorToast } from "../helpers/utility";

class AuthApiService {
  static init() {
    // Set the base URL if not already set
    // if (!authAxios.defaults.baseURL) {
    //   authAxios.defaults.baseURL = import.meta.env.VITE_APP_AUTH_URL;
    // }

    // Set default headers
    // authAxios.defaults.headers.common["Accept"] = "application/json";

    // Initialize interceptors (simplified without refresh logic)
    AuthApiService.setupRequestInterceptor();
    AuthApiService.setupResponseInterceptor();
  }

  static setupRequestInterceptor() {
    authAxios.interceptors.request.use(
      (config) => {
        // Only add token if it exists (for logout requests)
        const token = JwtService.getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  static setupResponseInterceptor() {
    authAxios.interceptors.response.use(
      (response) => response,
      (error) => {
       
        if (error.config.__isRetry) return Promise.reject(error);

        // Simplified error handling for auth-specific cases
        if (!error.response) {
          errorToast("Network Error - Please check your connection");
          return Promise.reject(error);
        }

        const status = error.response.status;
        const errorMessage =
          error.response?.data?.message || "Authentication failed";

        // Handle error responses
        if (status === 401) {
          error.config.__isRetry = true;
          AuthApiService.handleUnauthorizedError(errorMessage, status);
        } else if (status === 403) {
          error.config.__isRetry = true;
          AuthApiService.handleForbiddenError();
        } else {
          error.config.__isRetry = true;
          errorToast(errorMessage, status);
        }

        return Promise.reject(error);
      }
    );
  }

  // Preserved for external use (e.g., after successful login)
  static setAuthorizationHeader() {
    const token = JwtService.getToken();
    if (token) {
      authAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete authAxios.defaults.headers.common["Authorization"];
    }
  }

  static handleForbiddenError() {
    errorToast("You don't have permission to access this resource", 403);
    // Optional: router.push({ name: 'forbidden' });
  }

  static handleUnauthorizedError(errorMessage, status) {
    JwtService.destroyToken();
    if (router.currentRoute.name !== "login") {
      router.push({ name: "login" });
    }
    errorToast(errorMessage, status);
  }

  // HTTP request methods
  static query(resource, params) {
    return authAxios.get(resource, { params });
  }

  static get(resource) {
    return authAxios.get(resource);
  }

  static post(resource, params) {
    return authAxios.post(resource, params);
  }

  static update(resource, slug, params) {
    return authAxios.put(`${resource}/${slug}`, params);
  }

  static put(resource, params) {
    return authAxios.put(resource, params);
  }

  static patch(resource, params) {
    return authAxios.patch(resource, params);
  }

  static delete(resource) {
    return authAxios.delete(resource);
  }

  // static forgotPassword(email) {
  //   return authAxios.post("/auth/forgot-password", { email });
  // }
}

// Initialize once at app startup
AuthApiService.init();

export default AuthApiService;
